const $scrollBtn = $("[data-js-scroll-btn]")

$scrollBtn.on("click", (e) => {
  const hash = e.target.hash
  const scrollTarget = $(hash).offset().top

  $("html, body").animate({ scrollTop: scrollTarget }, 300)
})



// WEBPACK FOOTER //
// ./src/blocks/scrollBtn/scrollBtn.js